// extracted by mini-css-extract-plugin
module.exports = {"graphic":"FAQChest_graphic_20Xwb"};